import {
  CREATE_CONTRACT_SUCCESS,
  CREATE_SUSPEND_DOCUMENT_SUCCESS,
  FETCH_CONTRACT_SUCCESS,
  GET_CONTRACT_LOCATIONS,
  GET_CONTRACT_SUCCESS,
  SAVE_CONTRACT_QUERY,
  SET_CONTRACT_UPLOAD,
  UPLOAD_CONTRACT_DOCUMENT_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  document: {},
  locations: [],
  contractUploading: false,
  uploadData: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_CONTRACT_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_CONTRACT_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_CONTRACT_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_CONTRACT_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }
    case CREATE_SUSPEND_DOCUMENT_SUCCESS: {
      return {
        ...state,
        document: action.data,
      }
    }
    case GET_CONTRACT_LOCATIONS: {
      return {
        ...state,
        locations: action.data,
      }
    }
    case SET_CONTRACT_UPLOAD: {
      return {
        ...state,
        contractUploading: action.data,
      }
    }
    case UPLOAD_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        uploadData: action.data,
      }
    }

    default:
      return state;
  }
}
